import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Card } from '../domain/card';
import { CardActionBase } from '../domain/card-actions/card-action.base';
import { I18nKeys } from '@jump-tech-frontend/app-config';
import { DefaultFormComponent } from '../card/default/default-form.component';
import { ConsentFormComponent } from '../card/consent/consent-form.component';
import { InformationFormComponent } from '../card/information/information-form.component';
import { QuoteFormComponent } from '../card/quote/quote-form.component';
import { SummaryFormComponent } from '../card/summary/summary-form.component';
import { AddressFormComponent } from '../card/address/address-form.component';
import { OcrFormComponent } from '../card/ocr/ocr-form.component';
import { ImageCaptureFormComponent } from '../card/image-capture/image-capture-form.component';
import { CarouselMultipleFormComponent } from '../card/carousel/carousel-multiple-form.component';
import { CarouselFormComponent } from '../card/carousel/carousel-form.component';


@Component({
  selector: 'crds-card',
  template: `
    <div [attr.data-qa]="'cardKey_' + card.key">
      @switch (card.type) {
        @case ('carouselSingle') {
          <crds-carousel-form
            [form]="formGroup"
            [card]="card"
            [i18ns]="i18ns"
          ></crds-carousel-form>
        }
        @case ('carousel') {
          <crds-carousel-multiple-form
            [form]="formGroup"
            [card]="card"
            [i18ns]="i18ns"
          ></crds-carousel-multiple-form>
        }
        @case ('imageCapture') {
          <crds-image-capture-form
            [form]="formGroup"
            [card]="card"
            [i18ns]="i18ns"
            [deviceContext]="deviceContext"
          ></crds-image-capture-form>
        }
        @case ('ocr') {
          <crds-ocr-form [form]="formGroup" [card]="card" [i18ns]="i18ns"></crds-ocr-form>
        }
        @case ('address') {
          <crds-address-form
            [form]="formGroup"
            [card]="card"
            [i18ns]="i18ns"
            [deviceContext]="deviceContext"
          ></crds-address-form>
        }
        @case ('summary') {
          <crds-summary-form
            [form]="form"
            [card]="card"
            [i18ns]="i18ns"
            [formKey]="card.key"
          ></crds-summary-form>
        }
        @case ('quote') {
          <crds-quote-form
            [form]="formGroup"
            [card]="card"
            [i18ns]="i18ns"
            [formKey]="card.key"
          ></crds-quote-form>
        }
        @case ('info') {
          <crds-information-form [form]="form" [card]="card"></crds-information-form>
        }
        @case ('consent') {
          <crds-consent-form
            [form]="form"
            [formKey]="card.key"
            [card]="card"
            [i18ns]="i18ns"
          ></crds-consent-form>
        }
        @default {
          <crds-default-form
            [form]="form"
            [formKey]="card.key"
            [card]="card"
            [i18ns]="i18ns"
            [useJuiControls]="useJuiControls"
            [deviceContext]="deviceContext"
          ></crds-default-form>
        }
      }
    </div>
    `,
  styleUrls: ['../sass/relay.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CarouselFormComponent,
    CarouselMultipleFormComponent,
    ImageCaptureFormComponent,
    OcrFormComponent,
    AddressFormComponent,
    SummaryFormComponent,
    QuoteFormComponent,
    InformationFormComponent,
    ConsentFormComponent,
    DefaultFormComponent
]
})
export class CardComponent implements OnChanges {
  @Input() card: Card<CardActionBase>;
  @Input() form: UntypedFormGroup;
  @Input() i18ns: I18nKeys;
  @Input() useJuiControls?: boolean = false;
  @Input() deviceContext?: string = 'desktop';

  formGroup: UntypedFormGroup;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.card || !Object.prototype.hasOwnProperty.call(changes, 'card')) {
      return;
    }

    this.formGroup = this.form.get(this.card.key) as UntypedFormGroup;
  }
}
